import { createAction } from '@reduxjs/toolkit';
import { MANAGE_VIEW_ACTIONS } from './viewActionConstants';
import {
  IDisplayColumn,
  IQueryGroup,
  IUpdateFavorite,
  IselectedFilterQueryValidation,
  IGroup,
} from '../../interfaces/Slice.types';
import { IViewFolder } from '../../interfaces/CustomViewFolder';

export const setSpinnerView = createAction(
  MANAGE_VIEW_ACTIONS.SET_SPINNER_VIEW,
  function prepare(isShowSpinner: boolean) {
    return {
      payload: isShowSpinner,
    };
  }
);

export const setSelectedCustomViewFolder = createAction(
  MANAGE_VIEW_ACTIONS.SET_SELECTED_CUSTOM_VIEW,
  function prepare(viewId: string) {
    return {
      payload: viewId,
    };
  }
);

export const updateSelectedCustomFilterQueryName = createAction(
  MANAGE_VIEW_ACTIONS.SET_SELECTED_CUSTOM_VIEW_FOLDER_NAME,
  function prepare(customFilterQueryName: string) {
    return {
      payload: customFilterQueryName,
    };
  }
);

export const updateFavViewById = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_FAV_VIEW_BY_ID,
  function prepare(updateFavoriteById: IUpdateFavorite) {
    return {
      payload: updateFavoriteById,
    };
  }
);

export const updateDefaultViewById = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_DEFAULT_VIEW_BY_ID,
  function prepare(updateFavoriteById: string) {
    return {
      payload: updateFavoriteById,
    };
  }
);

export const updateQueryGroups = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_QUERY_GROUPS,
  function prepare(queryGroups: IQueryGroup[]) {
    return {
      payload: queryGroups,
    };
  }
);

export const updateQueryGroupInfo = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_QUERY_GROUP_INFO,
  function prepare(queryGroups: IGroup[]) {
    return {
      payload: queryGroups,
    };
  }
);

export const updateQueryDisplayColumns = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_QUERY_DISPLAY_COLUMNS,
  function prepare(DisplayColumn: IDisplayColumn[] | null | undefined) {
    return {
      payload: DisplayColumn,
    };
  }
);

export const updateFocusedParentFolder = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_FOCUSED_PARENT_FOLDER,
  function prepare(folder: IViewFolder | null) {
    return {
      payload: folder,
    };
  }
);

export const setSelectedFilterQueryValidation = createAction(
  MANAGE_VIEW_ACTIONS.SET_SELECTED_FILTER_QUERY_VALIDATION,
  function prepare(validation: IselectedFilterQueryValidation | null) {
    return {
      payload: validation,
    };
  }
);

export const updateShouldCallCheckAndAddUserToView = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_SHOULDCALL_CHECK_ADD_USER,
  function prepare(value: boolean) {
    return {
      payload: value,
    };
  }
);

export const setActionsCount = createAction(
  MANAGE_VIEW_ACTIONS.SET_ACTIONS_COUNT,
  function prepare(actionsCount: number) {
    return {
      payload: actionsCount,
    };
  }
);
